import { Grid, Stack, Box, Skeleton } from '@mui/material';
import useGlobalStyles from 'styles/globalStyles';
import { colors } from 'styles/colors';

export default function RegistryItemSkeleton() {
  const globalStyles = useGlobalStyles();

  return (
    <Grid
      className={globalStyles.registryItem}
      p={1.5}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        {/* Folder icon */}
        <Skeleton
          variant="rounded"
          width={90}
          height={55}
          sx={{ bgcolor: colors.skeleton }}
        />

        {/* Content */}
        <Box width="100%">
          {/* Registry name */}
          <Skeleton
            variant="text"
            height={24}
            width="60%"
            sx={{ bgcolor: colors.skeleton }}
          />

          {/* Owner */}
          <Stack direction="row" alignItems="center" spacing={1} my={0.5}>
            <Skeleton
              variant="circular"
              width={20}
              height={20}
              sx={{ bgcolor: colors.skeleton }}
            />

            <Skeleton
              variant="text"
              height={20}
              width="35%"
              sx={{ bgcolor: colors.skeleton }}
            />
          </Stack>

          {/* Date */}
          <Box mt={0.8}>
            <Skeleton
              variant="text"
              height={20}
              width="40%"
              sx={{ bgcolor: colors.skeleton }}
            />
          </Box>
        </Box>
      </Stack>
    </Grid>
  );
}